import CustomColor from './CustomColor'

export default CustomColor
